<template>
  <div v-if="!hasConsented" class="cookie-consent-overlay">
    <div class="cookie-consent-modal">
      
      <!-- Tabs -->
      <div class="cookie-tabs">
        <button class="tab-btn" :class="{ active: activeTab === 'consent' }" @click="activeTab = 'consent'">Consent</button>
        <button class="tab-btn" :class="{ active: activeTab === 'details' }" @click="activeTab = 'details'">Details</button>
        <button class="tab-btn" :class="{ active: activeTab === 'about' }" @click="activeTab = 'about'">About</button>
      </div>

      <div class="cookie-content">
        <!-- Details Tab Content -->
        <div v-if="activeTab === 'details'" class="tab-pane">
          
          <div class="cookie-category">
            <div class="category-header">
              <h4>Necessary cookies</h4>
              <label class="toggle-switch always-on">
                <input type="checkbox" checked disabled />
                <span class="slider round"></span>
              </label>
            </div>
            <p>These cookies help make a website usable by enabling basic functions like page navigation, website security and access to information that requires authentication.</p>
          </div>

          <div class="cookie-category">
            <div class="category-header">
              <h4>Preferences</h4>
              <label class="toggle-switch">
                <input type="checkbox" v-model="preferences" />
                <span class="slider round"></span>
              </label>
            </div>
            <p>These cookies enable storage of information that changes the way a website behaves or looks, like settings for your region.</p>
          </div>

          <div class="cookie-category">
            <div class="category-header">
              <h4>Statistics and Performance</h4>
              <label class="toggle-switch">
                <input type="checkbox" v-model="statistics" />
                <span class="slider round"></span>
              </label>
            </div>
            <p>These cookies help us to understand how visitors interact with our websites and are used for tracking which sections of the site are accessed the most in order to optimise content.</p>
          </div>

          <div class="cookie-category">
            <div class="category-header">
              <h4>Marketing</h4>
              <label class="toggle-switch">
                <input type="checkbox" v-model="marketing" />
                <span class="slider round"></span>
              </label>
            </div>
            <p>These cookies are used for tracking browsing activity and to customise and display ads that are relevant and engaging. This may involve sharing information about the way you use our website with third parties for the purposes of marketing and advertising.</p>
          </div>
          
          <div class="cookie-category">
            <div class="category-header">
              <h4>Unclassified</h4>
            </div>
            <p>Unclassified cookies are cookies that we are in the process of classifying, together with the providers of individual cookies.</p>
          </div>

        </div>

        <!-- Consent Tab Content (Summary) -->
        <div v-if="activeTab === 'consent'" class="tab-pane">
          <h3>We value your privacy</h3>
          <p>We and our partners use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept all", you consent to our use of cookies.</p>
          <div class="cross-domain">
            <strong>Cross-domain consent</strong>
            <p>Your consent applies to the following domains:</p>
            <ul>
              <li>meander.software</li>
              <li>do.meander.software</li>
            </ul>
          </div>
        </div>

        <!-- About Tab Content -->
        <div v-if="activeTab === 'about'" class="tab-pane">
          <h3>About Cookies</h3>
          <p>Cookies are small text files that can be used by websites to make a user's experience more efficient. The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission. This site uses different types of cookies.</p>
          <p>Learn more about who we are, how you can contact us and how we process personal data in our <router-link to="/privacy-policy">Privacy Policy</router-link>.</p>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="cookie-footer">
        <button class="btn-save" @click="savePreferences">Save preferences</button>
        <button class="btn-accept" @click="acceptAll">Accept all</button>
        <button class="btn-reject" @click="rejectAll">Reject all</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      hasConsented: true, // Default to true to prevent flash, will check local storage
      activeTab: 'details',
      preferences: false,
      statistics: false,
      marketing: false
    }
  },
  mounted() {
    this.checkConsent();
  },
  methods: {
    checkConsent() {
      setTimeout(() => {
        const consent = localStorage.getItem('meander_cookie_consent_v2');
        if (!consent) {
          this.hasConsented = false;
        } else {
          try {
            const data = JSON.parse(consent);
            this.preferences = data.preferences || false;
            this.statistics = data.statistics || false;
            this.marketing = data.marketing || false;
          } catch(e) {}
        }
      }, 500);
    },
    savePreferences() {
      const consentData = {
        necessary: true,
        preferences: this.preferences,
        statistics: this.statistics,
        marketing: this.marketing
      };
      this.setConsent(consentData);
    },
    acceptAll() {
      const consentData = {
        necessary: true,
        preferences: true,
        statistics: true,
        marketing: true
      };
      this.setConsent(consentData);
    },
    rejectAll() {
      const consentData = {
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false
      };
      this.setConsent(consentData);
    },
    setConsent(data) {
      localStorage.setItem('meander_cookie_consent_v2', JSON.stringify(data));
      this.hasConsented = true;
    }
  }
}
</script>

<style scoped>
.cookie-consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.cookie-consent-modal {
  background: #fff;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.cookie-tabs {
  display: flex;
  flex-direction: row; /* Mobile Fix: Ensures they stay side-by-side */
  border-bottom: 2px solid #eee;
}

.tab-btn {
  flex: 1;
  background: none;
  border: none;
  padding: 15px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.tab-btn.active {
  color: #222;
  border-bottom: 3px solid #222;
}

.cookie-content {
  padding: 20px 30px;
  overflow-y: auto;
  max-height: 60vh;
}

.tab-pane h3 {
  margin-top: 0;
  font-size: 20px;
  margin-bottom: 15px;
}

.tab-pane p {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
}

.cookie-category {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.cookie-category:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.category-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #222;
}

input:focus + .slider {
  box-shadow: 0 0 1px #222;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.toggle-switch.always-on .slider {
  background-color: #666;
  cursor: not-allowed;
}

.toggle-switch.always-on input:checked + .slider:before {
  transform: translateX(26px);
}

.cross-domain ul {
  list-style: disc;
  padding-left: 20px;
  margin-top: 10px;
  color: #555;
}

/* Footer Buttons */
.cookie-footer {
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
  border-top: 1px solid #eee;
  background: #fafafa;
  gap: 10px;
}

.cookie-footer button {
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: none;
}

.btn-save {
  background: #fff;
  border: 1px solid #ddd !important;
  color: #333;
}

.btn-save:hover {
  background: #f0f0f0;
}

.btn-reject {
  background: #fff;
  border: 1px solid #ddd !important;
  color: #333;
}

.btn-reject:hover {
  background: #f0f0f0;
}

.btn-accept {
  background: #222;
  color: #fff;
}

.btn-accept:hover {
  background: #000;
}

/* Responsive Styles */
@media only screen and (max-width: 767px) {
  .cookie-tabs {
    flex-direction: row; /* KEEP TABS HORIZONTAL ON MOBILE */
  }
  .tab-btn {
    padding: 15px 5px;
    font-size: 13px;
  }
  .cookie-content {
    padding: 15px 15px;
  }
  .cookie-footer {
    flex-direction: column;
    padding: 15px;
  }
  .cookie-footer button {
    width: 100%;
    margin-bottom: 10px;
  }
  .cookie-footer button:last-child {
    margin-bottom: 0;
  }
}
</style>
